export const initScheduledPopup = () => {
    // Load scheduled orders when popup opens
    document.querySelectorAll(".js-scheduled-popup-content").forEach((rToggle) => {
        rToggle.addEventListener("rToggle.afterOpen", async function () {
            const listEl = rToggle.querySelector(".js-scheduled-popup-list");
            if (!listEl || listEl.dataset.loaded === "true") return;

            const productId = listEl.dataset.productId;

            try {
                const response = await fetch(`/scheduled-orders/list?product_id=${productId}`);
                const data = await response.json();

                if (data.status && data.orders && data.orders.length > 0) {
                    listEl.innerHTML = data.orders
                        .map(
                            (order) => `
                        <div class="c-form__item c-form__item--checkbox">
                            <input type="checkbox"
                                class="c-form__input js-scheduled-popup-checkbox"
                                id="scheduled_${order.id}_${productId}"
                                value="${order.id}"
                                data-product-id="${productId}"
                                data-add-url="/scheduled-orders/add-product"
                                data-delete-url="/scheduled-orders/remove-product"
                                data-custom="custom"
                                ${order.has_product ? "checked" : ""}>
                            <label class="c-form__label" for="scheduled_${order.id}_${productId}">
                                <span class="sc-toggle"></span>
                                <span class="sc-text">${order.name}</span>
                            </label>
                        </div>
                    `
                        )
                        .join("");

                    initScheduledCheckboxes(listEl);
                } else {
                    listEl.innerHTML = `<div class="sc-empty">${
                        data.message || "Nemáte žiadne pravidelné objednávky"
                    }</div>`;
                }

                listEl.dataset.loaded = "true";
            } catch (error) {
                listEl.innerHTML = '<div class="sc-empty">Chyba pri načítaní</div>';
                console.error("Error loading scheduled orders:", error);
            }

            // Add thumb active state
            const thumbEl = rToggle.closest(".js-thumb");
            if (thumbEl) {
                thumbEl.classList.add("is-active");
            }
        });

        rToggle.addEventListener("rToggle.afterClose", function () {
            const thumbEl = rToggle.closest(".js-thumb");
            if (thumbEl) {
                thumbEl.classList.remove("is-active");
            }
        });
    });
};

const initScheduledCheckboxes = (container) => {
    container.querySelectorAll(".js-scheduled-popup-checkbox").forEach((checkbox) => {
        checkbox.addEventListener("change", async function () {
            const productId = this.dataset.productId;
            const scheduledOrderId = this.value;
            const isChecked = this.checked;
            const url = isChecked ? this.dataset.addUrl : this.dataset.deleteUrl;

            this.disabled = true;
            this.classList.add("is-loading");

            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                    body: JSON.stringify({
                        product_id: productId,
                        scheduled_order_id: scheduledOrderId,
                    }),
                });

                const data = await response.json();

                if (data.status) {
                    Eshop.alert(data.message, { type: "success" });
                    updateScheduledTriggerState(this);
                } else {
                    // Revert checkbox state on error
                    this.checked = !isChecked;
                    Eshop.alert(data.message || "Chyba", { type: "error" });
                }
            } catch (error) {
                // Revert checkbox state on error
                this.checked = !isChecked;
                Eshop.alert("Chyba pri spracovaní", { type: "error" });
                console.error("Error:", error);
            }

            this.disabled = false;
            this.classList.remove("is-loading");
        });
    });
};

const updateScheduledTriggerState = (checkbox) => {
    const container = checkbox.closest(".c-scheduled-popup");
    if (!container) return;

    const hasAnyChecked = container.querySelectorAll(".js-scheduled-popup-checkbox:checked").length > 0;
    const trigger = container.querySelector(".c-scheduled-popup__trigger");

    if (trigger) {
        trigger.classList.toggle("is-scheduled", hasAnyChecked);
    }
};

$(function () {
    initScheduledPopup();
});
